{
  "dss": {
    "button": {
      "back": "Terug",
      "cancel": "Annuleren",
      "close": "Sluiten",
      "confirmDelete": "Ja, verwijderen",
      "continue": "Doorgaan",
      "logout": "Uitloggen",
      "passwordReset": "Wachtwoord resetten",
      "save": "Opslaan",
      "verify": "Verifiëren"
    },
    "error": {
      "403": "U heeft geen toegang tot deze pagina.",
      "404": "Deze pagina bestaat niet.",
      "generic": "Er is een fout opgetreden. Probeer het later opnieuw.",
      "throttling": "Te veel pogingen. Deze bewerking is tijdelijk geblokkeerd.",
      "title": "Fout",
      "title403": "Toegang geweigerd",
      "title404": "Niet gevonden"
    },
    "footer": {
      "imprint": "Afdruk",
      "legalEntity": "ANDREAS STIHL NV, Veurtstraat 117, 2870 Puurs-Sint-Amands, België/Belgique <br> VAT Number: BE 0427.714.768",
      "privacy": "Gegevensbescherming",
      "terms": "Voorwaarden en Condities"
    },
    "label": {
      "CRMAccountNumber": "CRM Account nummer",
      "contact": "Contacten",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "Voornaam",
      "help": "Help",
      "language": "Taal",
      "lastname": "Naam",
      "male": "Mr.",
      "needHelp": "hulp nodig?",
      "newPassword": "Nieuw paswoord",
      "newPassword2": "Herhaal nieuw paswoord",
      "oldPassword": "Huidig paswoord",
      "organization": "Dealer",
      "password": "Paswoord",
      "required": "verplicht",
      "salutation": "Aanhef",
      "select": "Gelieve te kiezen"
    },
    "lang": {
      "nl": "Nederlands"
    },
    "link": {
      "contact": "https://support.stihl.com/nl-NL/websso-contact/",
      "faq": "https://support.stihl.com/nl-NL/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Registratie bevestigen",
        "wait": "Gelieve te wachten om de rekeningbevestiging te voltooien."
      },
      "otp": {
        "btnResend": "Verificatiecode opnieuw verzenden",
        "msg": {
          "invalidOTP": "Het ingevoerde eenmalige wachtwoord is ongeldig.",
          "resendFail": "Het is niet gelukt om de code opnieuw te versturen. Probeer het later nog eens."
        },
        "spamDetail": "Controleer uw mailbox en uw spamfolder op een e-mail van STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Heb je geen e-mail gekregen?",
        "subtitle": "Om verder te gaan, moet u uw e-mailadres verifiëren.",
        "title": "Controleer uw gebruikersaccount",
        "txtVerifyMail": "Voer de nieuwe verificatiecode in die we naar uw e-mailadres hebben gestuurd {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Er is niets om bij te werken.",
          "updateError": "Persoonsgegevens niet bijgewerkt.",
          "updated": "Persoonsgegevens werden bijgewerkt.",
          "userLoadErr": "Fout bij het laden van gebruikersgegevens. Probeer later opnieuw."
        },
        "secOrganization": "Organisatie",
        "secPersonal": "Persoonlijk",
        "secSettings": "Voorkeursinstellingen",
        "title": "Persoonlijke info"
      },
      "postPwSet": {
        "info": "Je kan nu je nieuw paswoord gebruiken",
        "link_name": "STIHL Direct account",
        "link_url": "https://www.stihl.nl",
        "title": "Je paswoord is gewijzigd"
      },
      "resetPW": {
        "title": "Je paswoord resetten"
      },
      "security": {
        "2fa": {
          "availableMethods": "Beschikbare 2FA-methoden:",
          "info": "Twee-factorauthenticatie (2FA) is een beveiligingsfunctie die een extra beschermingslaag aan uw account toevoegt. U moet hiervoor twee methoden gebruiken om in te loggen, in plaats van alleen een gebruikersnaam en wachtwoord.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Ontvang eenmalige codes per e-mail om authenticatieverzoeken te voltooien.",
            "oath": {
              "add": {
                "button": "Authenticator-app registreren"
              }
            }
          }
        },
        "authenticator": "Authenticator-app",
        "infoFederatedAccount": "Dit account wordt beheerd door de identiteitsprovider van uw organisatie, dus het wachtwoord kan hier niet worden gewijzigd. Om uw wachtwoord te wijzigen, meldt u zich aan via de inlogpagina van uw organisatie of neemt u contact op met uw IT-beheerder.",
        "lastUse": "Laatst gebruikt om {0}.",
        "msg": {
          "invalidPassword": "Ongeldig huidig wachtwoord.",
          "passwordAlreadyUsed": "Kan de laatste 5 wachtwoorden niet hergebruiken.",
          "pwUpdateError": "Er is een fout opgetreden bij het wijzigen van het wachtwoord.",
          "pwUpdated": "Het wachtwoord is veranderd."
        },
        "noDevice": "Niet geconfigureerd",
        "oathAdd": {
          "appInfo": "Authenticator-apps zoals {0}, {1}, etc. genereren eenmalige wachtwoorden die als tweede factor worden gebruikt tijdens het inloggen.",
          "badCode": "Ongeldige code, probeer het opnieuw.",
          "error": "Er is een fout opgetreden bij het registreren van het authenticatorapparaat.",
          "headScan": "1. Scan de QR-code met uw authenticator-app",
          "headVerify": "2. Controleer de code",
          "infoKey": "installatiesleutel",
          "infoKeyTitle": "Uw tweefactorgeheim",
          "infoScanBottom": "Kan niet scannen? U kunt de {0} gebruiken om uw authenticator-app handmatig te configureren.",
          "infoVerify": "Voer de code in die is gegenereerd door uw authenticator-app.",
          "success": "Uw authenticatorapparaat is geregistreerd. U kunt het nu gebruiken om in te loggen.",
          "title": "Registreer uw tweefactorauthenticatieapparaat"
        },
        "oathDelete": {
          "error": "Er is een fout opgetreden bij het verwijderen van het authenticatorapparaat.",
          "success": "Het authenticatorapparaat is verwijderd."
        },
        "passkeys": {
          "about": {
            "info1": "Passkeys zijn paren cryptografische sleutels (een publieke sleutel en een privésleutel) die worden opgeslagen door een authenticator die je beheert. De authenticator kan bewijzen dat een gebruiker aanwezig is en geautoriseerd is om de passkey te gebruiken. Authenticators bewijzen autorisatie met een pincode, toegangscode, biometrisch kenmerk of apparaatwachtwoord, afhankelijk van de mogelijkheden en configuratie van de authenticator. Authenticators zijn er in vele vormen, zoals een iPhone of Android-apparaat, Windows Hello, een FIDO2 hardwarebeveiligingssleutel of een wachtwoordbeheerder.",
            "info2": "Wanneer je je aanmeldt bij STIHL met een passkey, gebruikt je authenticator cryptografie met publieke sleutels om je identiteit aan STIHL te bewijzen zonder ooit de passkey te versturen. Passkeys zijn gekoppeld aan een websitedomein, zoals stihl-sso.com en vereisen een beveiligde verbinding, wat betekent dat de webbrowser weigert te authenticeren bij een phishingwebsite die op een vergelijkbare website lijkt. Deze eigenschappen maken wachtwoorden zeer phishingbestendig en veel moeilijker aan te vallen dan sms of TOTP 2FA, die wel gephisht kunnen worden.",
            "info3": "Cloud-ondersteunde wachtwoorddiensten maken het mogelijk om wachtwoorden te synchroniseren tussen apparaten (zoals Apple-apparaten, Android-apparaten of wachtwoordmanagers), zodat ze vanaf meer locaties kunnen worden gebruikt en minder snel verloren gaan. Zodra u een gesynchroniseerde wachtwoord op één apparaat hebt ingesteld, is die wachtwoord beschikbaar voor gebruik op meerdere apparaten die dezelfde dienst gebruiken. Als u bijvoorbeeld een wachtwoord registreert bij uw iCloud-account met behulp van Touch ID van uw MacBook, kunt u die wachtwoord vervolgens gebruiken met uw gezicht, vingerafdruk, pincode of apparaatwachtwoord op meerdere apparaten die aan hetzelfde iCloud-account zijn gekoppeld.",
            "title": "Over passkeys"
          },
          "add": {
            "button": "Nieuwe toegangssleutel toevoegen",
            "error": "Er is een fout opgetreden bij het toevoegen van de nieuwe toegangssleutel.",
            "success": "Er is een nieuwe toegangssleutel toegevoegd."
          },
          "delete": {
            "button": "Toegangssleutel verwijderen",
            "error": "Er is een fout opgetreden bij het verwijderen van deze toegangssleutel.",
            "success": "De toegangssleutel is verwijderd."
          },
          "edit": {
            "error": "Er is een fout opgetreden bij het opslaan van de naam van de toegangssleutel.",
            "name": "Naam van de toegangssleutel",
            "success": "De naam van de toegangssleutel is bijgewerkt.",
            "title": "Geef je toegangssleutel een naam om deze te onderscheiden van andere toegangssleutels"
          },
          "info": "Passkey is een eenvoudig en veilig alternatief voor wachtwoorden, waarmee je je identiteit kunt valideren met behulp van aanraking, gezichtsherkenning, een apparaatwachtwoord of een pincode.",
          "none": "Geen toegangssleutel geconfigureerd.",
          "reallyDelete": "Weet u zeker dat u de toegangssleutel wilt verwijderen?",
          "registeredPasskeys": "Uw geregistreerde toegangssleutels:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Weet u zeker dat u het authenticatieapparaat wilt verwijderen?",
        "secMFA": "Meervoudige authenticatie",
        "secPwdChange": "Paswoord veranderen",
        "title": "Aanmelden en beveiliging"
      },
      "setPW": {
        "acceptTC": "Wij verzoeken u in te stemmen met onze {terms} en onze {privacy} te lezen.",
        "killSSO": "Maak alle actieve sessies ongeldig",
        "msg": {
          "tokenExpired": "De wachtwoord link of code is verlopen. Volg de link om uw wachtwoord opnieuw in te stellen: {link}."
        },
        "privacy": "Opmerkingen gegevensbescherming",
        "terms": "STIHL account gebruiksvoorwaarden",
        "title": "Nieuw wachtwoord"
      }
    },
    "validations": {
      "hasDigit": "Moet cijfer(s) bevatten",
      "hasLowercase": "Moet kleine letter(s) bevatten",
      "hasSpecial": "Moet speciaal teken(s) bevatten: {chars}",
      "hasUppercase": "Moet (een) hoofdletter(s) bevatten",
      "invalidCharacters": "Bevat ongeldige tekens",
      "maxLength": "Maximaal {max} toegestane tekens",
      "minLength": "Minimum {min} tekens vereist",
      "notSameAsEmail": "Te vergelijkbaar met e-mailadres",
      "onlyValidCharactersAllowed": "Alleen letters, cijfers en spaties zijn toegestaan.",
      "required": "Verplichte waarde",
      "sameAsPassword": "De wachtwoorden komen niet overeen",
      "tcAccepted": "Wij verzoeken u onze algemene voorwaarden te accepteren en ons gegevensbeschermingsbeleid te lezen.",
      "validEmail": "Ongeldig e-mailadres.",
      "validOTP": "Voer de verificatiecode in."
    }
  }
}
